angular.module('Itao.HyperionAtlas').factory('HyperionDataService', [
  '$http',
  '$httpParamSerializerJQLike',
  'IndicatorService',
  'IndicatorCategoryService',
  'IndicatorSetService',
  'ColorSetService',
  'communeConfig',
  function ($http, $httpParamSerializerJQLike, IndicatorService, IndicatorCategoryService, IndicatorSetService, ColorSetService, communeConfig) {
    'use strict';
    //var rootUri = jQuery('#communeUserData').data('root-uri');
    var commune = communeConfig.communeID;
    var rootUri = '/de/api/';
    var publishedVersion = communeConfig.published;
    var ajaxTargetPid = 0;

    function getApiUrl(actionName, commune) {
      return rootUri + actionName + '/' + commune;
    }

    /**
     * Fetches DataLayerType data
     * @param typeUids
     * @returns {Promise} When resolved, an array of raw DataLayerTypes
     */
    function fetchDataLayerTypes(typeUids) {
      return $http
        .get(getApiUrl('listDataLayerTypes', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listDataLayerTypes',
            'arguments[commune]': commune,
            'arguments[typeUids]': typeUids ? typeUids.join(',') : '',
            'arguments[showUnpublished]': publishedVersion ? '0' : '1'
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('DataLayerTypes could not be loaded', response);
        });
    }

    /**
     * Fetches dataLayer data for a specific dataLayerTypeId
     * @param {int} dataLayerTypeUid the dataLayerType to fetch
     * @param {String} filterDistricts
     * @param indicatorCategory
     * @param {int} singleDataDistrict
     * @returns {Promise} When resolved, an array of raw DataLayers
     */
    function fetchDataLayersForType(dataLayerTypeUid, filterDistricts, indicatorCategory, singleDataDistrict) {
      return $http
        .get(getApiUrl('listDataLayers', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listDataLayers',
            'arguments[commune]': commune,
            'arguments[dataLayerType]': dataLayerTypeUid,
            'arguments[showUnpublished]': publishedVersion ? '0' : '1',
            'arguments[filterDistricts]': filterDistricts == null ? '' : filterDistricts,
            'arguments[indicatorCategory]': indicatorCategory ? indicatorCategory.join(',') : '',
            'arguments[singleDataDistrict]': singleDataDistrict || null
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('DataLayers for Type ' + dataLayerTypeUid + ' could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicators() {
      return $http
        .get(getApiUrl('listIndicators', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicators',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Indicators could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicatorsFromCategory(category) {
      return $http
        .get(getApiUrl('listIndicatorsFromCategory', commune), {
          params: {
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorsFromCategory',
            'arguments[commune]': commune,
            'arguments[category]': category
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Indicators from Category could not be loaded', response);
        });
    }

    /**
     * Fetches indicator data
     * @returns {Promise} When resolved, an array of raw Indicators
     */
    function fetchIndicatorSetsFromCategory(category) {
      return $http
        .get(getApiUrl('listIndicatorSetsFromCategory', commune), {
          params: {
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorSetsFromCategory',
            'arguments[commune]': commune,
            'arguments[category]': category
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Sets from Category could not be loaded', response);
        });
    }

    /**
     * Fetches indicator-category data
     * @returns {Promise} When resolved, an array of raw IndicatorCategories
     */
    function fetchIndicatorCategories() {
      return $http
        .get(getApiUrl('listIndicatorCategories', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorCategories',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Categories could not be loaded', response);
        });
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function fetchIndicatorSets() {
      return $http
        .get(getApiUrl('listIndicatorSets', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorSets',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Sets could not be loaded', response);
        });
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function fetchColorSets(uid) {
      return $http
        .get(getApiUrl('listColorSets', commune), {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listColorSets',
            'arguments[commune]': commune,
            'arguments[uid]': uid
          }
        }).then(function (response) {
          return response.data.data;
        }, function (response) {
          console.error('Colorsets could not be loaded', response);
        });
    }

    /**
     * creates the Indicator objects from raw Indicator data
     * @param {Object} response the indicators as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorsToIndicators(response) {
      var indicatorObject = {};
      for (var indicatorUid in response) {
        if (response.hasOwnProperty(indicatorUid)) {
          var rawIndicator = response[indicatorUid];
          indicatorObject[indicatorUid] = IndicatorService.createIndicator(
            rawIndicator.uid,
            rawIndicator.name,
            rawIndicator.indicatorKey,
            rawIndicator.unit,
            rawIndicator.category,
            rawIndicator.type,
            rawIndicator.list,
            rawIndicator.isDefault,
            rawIndicator.defaultScale,
            rawIndicator.defaultColorSet,
            rawIndicator.indication,
            rawIndicator.hint,
            rawIndicator.source,
            rawIndicator.statement,
            rawIndicator.calculation,
            rawIndicator.defaultInvert,
            rawIndicator.class,
            rawIndicator.sorting,
            rawIndicator.categorical,
            rawIndicator.listIndex,
            rawIndicator.prefix,
            rawIndicator.redLines
          );
        }
      }
      return indicatorObject;
    }

    /**
     * creates the Indicator objects from raw Indicator data
     * @param {Object} response the indicatorCategories as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorCategoriesToIndicatorCategories(response) {
      var categoriesObject = {};
      for (var indicatorCategoryUid in response) {
        if (response.hasOwnProperty(indicatorCategoryUid)) {
          var rawIndicatorCategory = response[indicatorCategoryUid];
          categoriesObject[indicatorCategoryUid] = IndicatorCategoryService.createIndicatorCategory(
            rawIndicatorCategory.uid,
            rawIndicatorCategory.name,
            rawIndicatorCategory.parent,
            rawIndicatorCategory.class,
            rawIndicatorCategory.sorting
          );
        }
      }
      return categoriesObject;
    }

    /**
     * creates the IndicatorSet objects from raw IndicatorSet data
     * @param {Object} response the indicatorSets as given by the JSON API
     * @returns {Array}
     */
    function mapRawIndicatorSetsToIndicatorSets(response) {
      return response.map(function (rawIndicatorSet) {
        return IndicatorSetService.createIndicatorSet(
          rawIndicatorSet.uid,
          rawIndicatorSet.title,
          rawIndicatorSet.lists,
          rawIndicatorSet.category,
          rawIndicatorSet.class,
          rawIndicatorSet.colorSet,
          rawIndicatorSet.sorting
        );
      });
    }

    /**
     * creates the ColorSet objects from raw ColorSet data
     * @param {Object} response the indicatorSets as given by the JSON API
     * @returns {Array}
     */
    function mapRawColorSetsToColorSets(response) {
      return response.map(function (rawColorSet) {
        return ColorSetService.createColorSet(
          rawColorSet.uid,
          rawColorSet.name,
          rawColorSet.colors
        );
      });
    }

    function mapRawDataLayers(data) {
      if (!data) return {};
      return Object.keys(data).reduce(function (years, year) {
        years[year] = data[year];
        var parsedJson = years[year].geo_json ? JSON.parse(years[year].geo_json) : null;
        var keysInJson = [];
        if (parsedJson != null && parsedJson.hasOwnProperty('features')) {
          keysInJson = parsedJson.features
            .map(function (feature) {
              return feature.properties.key;
            });
        }
        years[year].districts = Object.keys(years[year].districts).reduce(function (districts, districtUid) {
          districts[districtUid] = years[year].districts[districtUid];
          districts[districtUid].hasNoGeoData = keysInJson.indexOf(districts[districtUid].key) === -1;
          return districts;
        }, {});
        return years;
      }, {});
    }

    /**
     * Fetches indicatorSet data
     * @returns {Promise} When resolved, an array of raw IndicatorSets
     */
    function convertHtml(code, context) {
      return $http
        .post(rootUri, {
          'code': code,
          'context': context
        }, {
          headers: {'Content-Type': 'application/json; charset=utf-8'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'convertHtmlToPdf'
          }
        });
    }

    return {

      /**
       * Fetches all dataLayerTypes data
       * @returns {Promise} When resolved, an array of DataLayerTypes
       */
      getDataLayerTypes: fetchDataLayerTypes,

      /**
       * Fetches dataLayer data for a specific DataLayerType object and transforms it to DataLayerTypes
       * @param {int} dataLayerTypeUid the dataLayerType to fetch
       * @param {string} filterDistricts
       * @param indicatorCategory
       * @param {int} singleDataDistrict
       * @returns {Promise} When resolved, an array of DataLayers
       */
      getDataLayersForDataLayerType: function (type, filterDistricts, indicatorCategory, singleDataDistrict) {
        return fetchDataLayersForType(type, filterDistricts, indicatorCategory, singleDataDistrict)
          .then(mapRawDataLayers);
      },

      /**
       * Fetches all indicator data and transforms it to Indicators
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicators: function () {
        return fetchIndicators()
          .then(mapRawIndicatorsToIndicators);
      },

      /**
       * Fetches all indicator from a specified Category data and transforms it to Indicators
       * @param {int} category the categoryUid
       * @param {int} toggleCategory the categoryUid
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorsFromCategory: function (category, toggleCategory) {
        return fetchIndicatorsFromCategory(toggleCategory ? category + ',' + toggleCategory : category)
          .then(mapRawIndicatorsToIndicators);
      },

      /**
       * Fetches all indicator from a specified Category data and transforms it to Indicators
       * @param {int} category the categoryUid
       * @param {int} toggleCategory the categoryUid
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorSetsFromCategory: function (category, toggleCategory) {
        return fetchIndicatorSetsFromCategory(toggleCategory ? category + ',' + toggleCategory : category)
          .then(mapRawIndicatorSetsToIndicatorSets);
      },

      /**
       * Fetches all indicator-categories data and transforms it to IndicatorCategories
       * @returns {Promise} When resolved, an array of Indicators
       */
      getIndicatorCategories: function () {
        return fetchIndicatorCategories()
          .then(mapRawIndicatorCategoriesToIndicatorCategories);
      },

      /**
       * Fetches all indicator-sets data and transforms it to IndicatorSets
       * @returns {Promise} When resolved, an array of IndicatorSets
       */
      getIndicatorSets: function () {
        return fetchIndicatorSets()
          .then(mapRawIndicatorSetsToIndicatorSets);
      },

      /**
       * Fetches all indicator-sets data and transforms it to IndicatorSets
       * @returns {Promise} When resolved, an array of IndicatorSets
       */
      getColorSets: function (uid) {
        return fetchColorSets(uid)
          .then(mapRawColorSetsToColorSets);
      },

      /**
       *
       */
      convertHtml: function (code, context) {
        return convertHtml(code, context);
      }
    };
  }
]);
